import { useContext } from 'react';
import { ToastHandlerContext } from '../components/ToastHandler';

function useToastHandler() {
  const { toasts, addToast, removeToast } = useContext(ToastHandlerContext);
  return { toasts, addToast, removeToast };
}

export default useToastHandler;